import React from 'react';
import { cn } from '@/lib/utils';

export function Button({ as: Tag = 'button', variant = 'primary', size = 'md',
                        className = '', children, ...props }) {
  const variants = {
    primary: 'bg-brand-primary text-white hover:bg-brand-primary-hover border-carbon',
    dark: 'bg-carbon text-canvas hover:bg-black border-carbon',
    outline: 'bg-white text-carbon hover:bg-surface-alt border-carbon',
    accent: 'bg-brand-accent text-white hover:brightness-95 border-carbon',
    ghost: 'bg-transparent text-carbon hover:bg-surface-alt border-transparent',
  };
  const sizes = {
    sm: 'min-h-[40px] px-3 text-sm',
    md: 'min-h-[48px] px-5 text-base',
    lg: 'min-h-[56px] px-6 text-lg',
  };
  return (
    <Tag
      className={cn(
        'inline-flex items-center justify-center gap-2 border-2 font-display font-bold uppercase tracking-widest',
        'btn-hard select-none disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant], sizes[size], className
      )}
      {...props}
    >
      {children}
    </Tag>
  );
}

export function IconButton({ className = '', children, ...props }) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center w-12 h-12 border-2 border-carbon bg-white text-carbon',
        'btn-hard',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
